/**
 * created by li si yi
 * 组图待办处理
 */
import React, {Component} from 'react';
import {connect} from "react-redux";
import Photos from "../../../../mediaRelease/mediaJump/photos/photos";
import BaseComponent from "../../../../../base/BaseComponent";

class PhotosEditor extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            data:{}
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    data = {};

    //判断类型
    isSupport(data) {
        this.data = data;
        // console.log("webNews----------", data);
        if (this.data && this.data.data && this.data.data.id && this.data.data.atlasList && this.data.data.atlasList.length && this.data.activitiCategoryKey === "webNews") {
            return true;
        }
        return false;
    };
    getIcon = (data) => {
        let icon = 'WebsiteIcon';
        return icon
    };
    //刷新回调
    handle = (data, call) => {
        this.setState({
            data:data?.data
        },()=>{
            this.photos.showEditModal(data.data, () => call && call());
        })
    };

    render() {
        return (
            <div style={{display: 'none'}}>
                <Photos ref={ref => this.photos = ref} dynamicParams={{
                    mediaId:this.state.data?.mediaId,
                    treeId:this.state.data?.treeId,
                    contentId:this.state.data?.contentId,
                }}/>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        currentUser: state.systemReducer.currentUser,
    }
}

export default connect(mapStateToProps, null, null, {forwardRef: true})(PhotosEditor)